import { ILLGenericKeys } from "./ll-generic-keys.model";

export class ILLNameDescription {
 name: ILLGenericKeys;
 description: string;
}
